import { z } from 'zod/v4';
import { PaymentPlanEntryStatus, PaymentPlanStatus, } from '../../economy/payment-plans/index.js';
import { PerformedBySchema } from '../../performed-by/index.js';
import { ToolCategory, ToolName, ToolPolicy, ToolWeight } from '../types.js';
const inputSchema = z.object({
    paymentPlanId: z
        .uuid()
        .describe('The plan to fetch. Obtain via search_payment_plans — do not invent ids.'),
});
const outputSchema = z.object({
    paymentPlanId: z.uuid(),
    status: z.enum(PaymentPlanStatus),
    installments: z.array(z.object({
        amount: z.string().describe('Decimal amount in the case currency.'),
        dueDate: z.iso.date(),
        status: z.enum(PaymentPlanEntryStatus),
        paidAmount: z.string().describe('Decimal amount in the case currency.'),
        paidAt: z.iso.datetime().nullable(),
    })),
    installmentCount: z.number().int(),
    installmentsTruncated: z.boolean(),
    paidInstallmentCount: z.number().int(),
    totalScheduled: z.string().describe('Decimal amount in the case currency.'),
    totalPaid: z.string().describe('Decimal amount in the case currency.'),
    nextDueDate: z.iso.date().nullable(),
    nextDueAmount: z
        .string()
        .nullable()
        .describe('Decimal amount in the case currency.'),
    daysUntilNextDue: z.number().int().nullable(),
    createdAt: z.iso.datetime(),
    createdBy: PerformedBySchema.nullable(),
    createdNote: z.string().nullable(),
    cancelledAt: z.iso.datetime().nullable(),
    cancelledBy: PerformedBySchema.nullable(),
    cancelledReason: z.string().nullable(),
});
export const getPaymentPlanTool = {
    name: ToolName.GetPaymentPlan,
    category: ToolCategory.Vouchers,
    weight: ToolWeight.Light,
    version: 1,
    defaultPolicy: ToolPolicy.AutoRun,
    llmDescription: 'Read full details of a payment plan: status, installments with their statuses and paid amounts, totals, next due, and cancellation info if cancelled.',
    inputSchema,
    outputSchema,
};
//# sourceMappingURL=get-payment-plan.js.map